import React from 'react'
import { Link } from 'react-router-dom'
import createReactClass from 'create-react-class'

const MgHeader = createReactClass({
	render() {
		const { migrate, logo } = this.props
		return <header>
			<div className="bv-container container">
				<div className="row">
					<div className="col-xs-12 col-md-12 bv-top-menu" style={{ height: "66px" }}>
						<Link className="bv-logo" to={ `/migration/${  migrate.get('gid')}` }>{ logo() }</Link>
						<ul className="bv-top-right-nav pull-right">
							<li style={{ border: "hidden" }}><i className="mdi mdi-account"></i>{ migrate.get('email') }</li>
						</ul>
					</div>
				</div>
			</div>
		</header>
	}
})

export default MgHeader
